<template>
  <div>
    <!-- blog-area start -->
    <div class="blog-details-area mg-top-90 text-center">
      <div class="container">
        <div class="blog-details-inner">      
          <div class="details my-4">
            <h6 class="title mb-4 text-success">Sign Out</h6>
            <p>See you again soon!</p>
            <p>
              <i class="fa fa-hand-paper-o" aria-hidden="true"></i>
            </p>
            <p>Bye.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- blog-area End -->
  </div>
</template>

<script>
export default {
  name: "Logout",
  async mounted() {
    await this.sleep(2000);
    this.$store.dispatch("signoutUser");
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>

<style></style>